/*
  WanderS Light / Dark mode switch.
  - The initial mode is applied before first paint by the inline script in
    layout/theme.liquid (reads the same storage key). Default is dark; the
    device preference is intentionally not used.
  - Clicking any [data-color-mode-toggle] flips the mode, saves it, and keeps
    every toggle's aria-checked in sync. Other open tabs follow via `storage`.
  - Only touches html[data-color-mode]; no cart, pricing or B2B logic here.
*/
(function () {
  var STORAGE_KEY = 'wanders-color-mode';
  var root = document.documentElement;

  function currentMode() {
    return root.getAttribute('data-color-mode') === 'dark' ? 'dark' : 'light';
  }

  function syncToggles() {
    var isDark = currentMode() === 'dark';
    var toggles = document.querySelectorAll('[data-color-mode-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].setAttribute('aria-checked', isDark ? 'true' : 'false');
    }
  }

  function applyMode(mode, persist) {
    root.classList.add('color-mode-switching');
    root.setAttribute('data-color-mode', mode);
    if (persist) {
      try {
        window.localStorage.setItem(STORAGE_KEY, mode);
      } catch (error) {
        /* Storage blocked (private mode, cookies off): mode still applies for this page. */
      }
    }
    syncToggles();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        root.classList.remove('color-mode-switching');
      });
    });
    document.dispatchEvent(new CustomEvent('color-mode:change', { detail: { mode: mode } }));
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-color-mode-toggle]');
    if (!toggle) return;
    event.preventDefault();
    applyMode(currentMode() === 'dark' ? 'light' : 'dark', true);
  });

  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY) return;
    applyMode(event.newValue === 'light' ? 'light' : 'dark', false);
  });

  /* Toggles inside sections re-rendered by the theme editor or section rendering */
  document.addEventListener('shopify:section:load', syncToggles);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncToggles);
  } else {
    syncToggles();
  }
})();
